module.exports = __webpack_public_path__ + "static/media/Game-perf-contest-dashboard.3b104ef0.png";